/*
* Html attribute class based inteface for Sollio utilities
* Each utility should be an exported class
* Initialise the class in this file with new YourUtilityClass(parameter)
* This will use the constructor method. Pass the parameters.
 */

//Set the languageDuSite property of window
export class LanguageUtility {
  constructor() {
    window.languageDuSite = document.documentElement.lang;
  }
}

//Retrieve all link on website and add external class when needed
export class ExternalUrlUtility {
  constructor() {
    let links = document.querySelectorAll('.is-external');
    links.forEach((link) => {
      if (link.host !== window.location.host) {
        link.classList.remove('is-external');
        link.classList.add('external');
        link.target = '_blank';
      }
    });
  }
}

//Drupal form error messages anchor link fix (offset menu height)
export class ErrorMessageAnchorLink {
  containerSelector = '.messages--error';
  scrollAdjust = 222;
  keywords = ['media', 'medias', 'careers', 'carrieres']

  constructor() {
    let currentUrl = window.location.pathname.split('/');
    currentUrl = currentUrl[currentUrl.length - 2];
    if (this.keywords.includes(currentUrl)) {
      this.scrollAdjust = 500;
    }
    setTimeout(() => {
      if (document.querySelector(this.containerSelector)) {
        let container = document.querySelector(this.containerSelector);
        let anchorLinks = container.querySelectorAll('a');
        anchorLinks.forEach((link) => {
          link.addEventListener('click', (_e) => {
            _e.preventDefault();
            let anchor = link.href.split('#')[1];
            let element = document.querySelector(`#${anchor}`);
            if (element.classList.contains('form-select')) {
              element = element.parentElement.querySelector('.select-selected');
              element.focus();
            }
            const y = element.getBoundingClientRect().top + window.scrollY - this.scrollAdjust;
            this.scrollToAnchor(y);
          })
        });
      }
    }, 0);

  }

  scrollToAnchor(topPos, scrollBehavior = 'smooth') {
    window.scrollTo({
      top: topPos, // scroll so that the element is at the top of the view
      behavior: scrollBehavior // smooth scroll
    })
  }
}

//Retrieve all link on website and add external class when needed
export class PrintUtility {
  printComponents = null;

  constructor(printSelectors) {
    this.printComponents = document.querySelectorAll(printSelectors);
    if (this.printComponents !== null) {
      this.printComponents.forEach((component) => {
        component.addEventListener('click', (_e) => {
          _e.preventDefault();
          window.print();
        })
      });
    }
  }
}

//Equalize rows in a column
//Work for only 1 column in a page
//Example in contact cards

export class EqualizeColumnMultipleRow {
  highest = 0;
  colum = null;
  rows = null;

  constructor() {
    this.getHighest();
    this.parseHighest();
    window.addEventListener('resize', () => {
      this.getHighest();
      this.parseHighest();
    });
  }

  getHighest() {
    this.column = document.querySelector('.js-equalize-column');
    if (this.column) {
      this.rows = this.column.querySelectorAll('.js-equalize-row');
      if (this.rows) {
        this.rows.forEach((row, _rowIndex) => {
          if (row.offsetHeight > this.highest) {
            this.highest = row.offsetHeight;
          }
        });
      }
    }

  }

  parseHighest() {
    if (this.rows) {
      this.rows.forEach((row, _rowIndex) => {
        if (row.offsetHeight < this.highest) {
          row.style.height = `${this.highest}px`;
        }
      });
    }
  }
}


export class EventsListener {
  constructor() {
    //Overriding addEventListener prototype to add getEventListener;
    EventTarget.prototype._addEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (eventType, eventHandler, eventOptions) {
      if (eventOptions == undefined) eventOptions = false;
      this._addEventListener(eventType, eventHandler, eventOptions);
      if (!this.eventListenerList) this.eventListenerList = {};
      if (!this.eventListenerList[eventType]) this.eventListenerList[eventType] = [];
      this.eventListenerList[eventType].push({listener: eventHandler, options: eventOptions});
    };
    EventTarget.prototype._getEventListeners = function (eventTarget) {
      if (!this.eventListenerList) this.eventListenerList = {};
      if (eventTarget == undefined) {
        return this.eventListenerList;
      }
      return this.eventListenerList[eventTarget];
    };
  }

  _hasEvents(events) {
    for (let evt of Object.keys(events)) {
      return true;
    }
    return false;
  }
}


window.addEventListener('DOMContentLoaded', () => {
  new LanguageUtility();
  new ExternalUrlUtility();
  new PrintUtility('.js-print-selector');
  new EqualizeColumnMultipleRow();
  new ErrorMessageAnchorLink();
  window.eventListener = new EventsListener();
});
